import React from 'react';
import "./style.css";

const Badge = ({ children, type }) => {
    return (
        <span className={`badge badge-${type}`}>{children}</span>
    );
}

export default Badge;